import { PriceStrategy } from '@snap-types/models/enums';
import type { PriceStrategyConfigWithRelations } from '@snap-types/models/price-strategy-config';

/**
 * Gets the allowFallback value for a given price strategy from the price strategy configs.
 *
 * @param priceStrategy - The price strategy to look up
 * @param priceStrategyConfigs - Array of price strategy configurations, or undefined
 * @returns The allowFallback value for the strategy, or false if not found or configs are undefined
 */
export function getAllowFallback(
  priceStrategy: PriceStrategy,
  priceStrategyConfigs?: PriceStrategyConfigWithRelations[],
): boolean {
  if (!priceStrategyConfigs) {
    return false;
  }

  const config = priceStrategyConfigs.find(
    (cfg) => cfg.priceStrategyType === priceStrategy,
  );

  return config?.allowFallback ?? false;
}
